import React from 'react';

interface TableResultProps {
  headers?: string[];
  rows?: any[][];
}

const TableResult: React.FC<TableResultProps> = ({ headers = [], rows = [] }) => {
  // Ensure headers and rows are arrays
  const safeHeaders = Array.isArray(headers) ? headers : [];
  const safeRows = Array.isArray(rows) ? rows : [];

  // If no data, show a message
  if (safeHeaders.length === 0 && safeRows.length === 0) {
    return (
      <div className="p-3 text-[var(--rhea-text-secondary)]">
        No table data available
      </div>
    );
  }

  return (
    <div className="overflow-x-auto p-3">
      <table className="min-w-full divide-y divide-[var(--rhea-card-border)]">
        {safeHeaders.length > 0 && (
          <thead>
            <tr>
              {safeHeaders.map((header, index) => (
                <th
                  key={index}
                  className="px-3 py-2 text-left text-xs font-medium text-[var(--rhea-text-secondary)] uppercase tracking-wider"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody className="divide-y divide-[var(--rhea-card-border)]">
          {safeRows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Array.isArray(row) ? row.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className="px-3 py-2 text-sm text-[var(--rhea-text-primary)]"
                >
                  {cell}
                </td>
              )) : (
                <td className="px-3 py-2 text-sm text-[var(--rhea-text-primary)]">
                  {String(row)}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableResult; 